import { SvgIcon, SvgIconProps } from '@mui/material'

const BackpackIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.5 5V4C16.5 3.46957 16.2893 2.96086 15.9142 2.58579C15.5391 2.21071 15.0304 2 14.5 2H10.5C9.96957 2 9.46086 2.21071 9.08579 2.58579C8.71071 2.96086 8.5 3.46957 8.5 4V5C7.43913 5 6.42172 5.42143 5.67157 6.17157C4.92143 6.92172 4.5 7.93913 4.5 9V20C4.5 20.5304 4.71071 21.0391 5.08579 21.4142C5.46086 21.7893 5.96957 22 6.5 22H18.5C19.0304 22 19.5391 21.7893 19.9142 21.4142C20.2893 21.0391 20.5 20.5304 20.5 20V9C20.5 7.93913 20.0786 6.92172 19.3284 6.17157C18.5783 5.42143 17.5609 5 16.5 5ZM10.5 4H14.5V5H10.5V4ZM12.5 9L14.5 11L12.5 13L10.5 11L12.5 9ZM18.5 16H9.5V18H8.5V16H6.5V15H18.5V16Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default BackpackIcon
